module.exports = __webpack_public_path__ + "img/me_logo.f58bf1da.png";